var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusicAlbum(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2C5.44772 2 5 2.44772 5 3H15C15 2.44772 14.5523 2 14 2H6ZM2 6C2 4.89543 2.89543 4 4 4H16C17.1046 4 18 4.89543 18 6V16C18 17.1046 17.1046 18 16 18H4C2.89543 18 2 17.1046 2 16V6ZM9.71428 12.334V8.5431C9.71428 8.30281 9.86461 8.08819 10.0904 8.00608L12.0904 7.2788C12.4631 7.14329 12.8571 7.41928 12.8571 7.81583V8.88971C12.8571 9.12791 12.7094 9.34112 12.4864 9.42476L10.7568 10.0733C10.6453 10.1152 10.5714 10.2218 10.5714 10.3409V13.5714C10.5714 14.3604 9.80391 15 8.85714 15C7.91036 15 7.14285 14.3604 7.14285 13.5714C7.14285 12.7825 7.91036 12.1429 8.85714 12.1429C9.16938 12.1429 9.46213 12.2124 9.71428 12.334Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicAlbum);
export default __webpack_public_path__ + "static/media/music-album.80e3603f4cfcca4ca2b0f9d3510e856d.svg";
export { ForwardRef as ReactComponent };